const EN_US = 'en-us';
const EN_AU = 'en-au';
const EN_UK = 'en-gb';
const DE_DE = 'de-de';
const EN_IN = 'en-in';

const geoSpaceIdMap = {
  ['global']: process.env.CONTENTFUL_GLOBAL_SPACE_ID,
  [EN_US]: process.env.CONTENTFUL_US_SPACE_ID,
  [EN_AU]: process.env.CONTENTFUL_AU_SPACE_ID,
  [EN_UK]: process.env.CONTENTFUL_UK_SPACE_ID,
  [DE_DE]: process.env.CONTENTFUL_DE_SPACE_ID,
  [EN_IN]: process.env.CONTENTFUL_IN_SPACE_ID
};

/**
 * Returns the associated spaceId for a given geo space slug/string. Returns the
 * US spaceId by default.
 *
 * @param {string} geoSpace
 */
function getSpaceId(geoSpace) {
  return geoSpaceIdMap[geoSpace] || geoSpaceIdMap['global'];
}

export { EN_US, EN_AU, EN_UK, DE_DE, EN_IN, getSpaceId };
